import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Controller } from 'react-hook-form';
import { useState } from 'react';



function ControlledTextField({control, name, label, errors, className, autoFocus, width, type, infoText, readOnly, ...props}) {
   const useClasses = className ? className : "mt-8 mb-16";
   const [showPassword, setShowPassword] = useState(false);
   const isPassword = type === 'password';
   const useType = isPassword ? (showPassword ? 'text' : 'password') : (type || 'text');
   
   const sxProps= width ? { width: width } : undefined;
   
   const handleTogglePassword = () => {
     setShowPassword(!showPassword);
   };
   
   return (
     <Controller
        name={name}
        control={control}
        render={({ field }) => ( 
        	 <TextField
              {...field}
              value={field.value || ''}
              sx={sxProps}
              id={name}
              className={useClasses}
              label={label}
              autoFocus={autoFocus}
              type={useType}
              error={!!errors[name]}
              helperText={errors[name]?.message ? errors[name].message : infoText}
              variant="outlined"
              fullWidth={!width}
              inputProps={{ 
                readOnly: Boolean(readOnly),
                'data-testid': `input-${name}`
              }}
              InputProps={isPassword ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleTogglePassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              } : undefined}
              {...props}
            />
        )}
      />
   );
 
}

export default ControlledTextField;
